import React from 'react';
import IAcknowledgeBox from './IAcknowledgeBox';
import * as style from './AcknowledgeBoxStyle.module.scss'
import { LightboxComponent } from '@company/components/LightboxComponent/LightboxComponent';

const AcknowledgeBox: React.FunctionComponent<IAcknowledgeBox> = (props) => {
  const {} = props;

  return (
    <LightboxComponent closePreview={props.closeLightbox} isVisible={props.isVisible} small={true}>
      <div className={style.content}>
        <p className={style.text}>{props.text}</p>
        <button className={style.button} onClick={props.closeLightbox}>
          Continue
        </button>
      </div>
    </LightboxComponent>
  );
};

export default AcknowledgeBox;
